import { environment } from 'src/environments/environment';

export const showValidateButton = (environment as any).SHOW_VALIDATE_BUTTON === 'true';
